import { Injectable } from '@angular/core';
import { CommonService } from '../service/common.service';
import * as title from '../config/title';
import * as color from '../config/colors';
import * as legend from '../config/legend';
import * as xAxis from '../config/xAxis';
import * as yAxis from '../config/yAxis';
import * as series from '../config/series';
import * as tooltip from '../config/tootip';
import * as initOpts from '../config/initOpts';
import * as geo from '../config/geo';
import * as visualMap from '../config/visualMap';
import * as textStyle from '../config/textStyle';
import { cloneDeep } from 'lodash'
import { EChartOption } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class ChartOptionService {

  style = this.commonService.changeFontSize();

  constructor(
    private commonService: CommonService
  ) { }

  getChartColors(theme: string) {
    let temColor = []
    switch (theme) {
      case "darkMode":
        temColor = cloneDeep(color.darkModeColors)
        return temColor;
      default:
        temColor = cloneDeep(color.defaultColors)
        return temColor;
    }
  }

  getChartTitle() {
    return {
      show: false,
      text: ''
    };
  }

  getChartLegend() {
    return legend.getLegendBottomScroll(this.style);
  }

  getChartxAxisValue(number: Number) {
    if (number < 2) {
      return [xAxis.getDefaultXaxisOfValue(this.style)]
    }
    let xAxisOption = [];
    for (let i = 0; i < number; i++) {
      xAxisOption.push(xAxis.getDefaultXaxisOfValue(this.style))
    }
  }

  getChartxAxis(number: Number) {
    if (number < 2) {
      return [xAxis.getDefaultXaxisOfCategory(this.style)]
    }
    let xAxisOption = [];
    for (let i = 0; i < number; i++) {
      xAxisOption.push(xAxis.getDefaultXaxisOfCategory(this.style));
    }
    return xAxisOption;
  }

  getChartyAxisCategory(number: Number): EChartOption.YAxis[] {
    if (number < 2) {
      return [yAxis.getDefaultYaxisOfCategory(this.style)]
    }
    let yAxisOption = [];
    for (let i = 0; i < number; i++) {
      yAxisOption.push(yAxis.getDefaultYaxisOfCategory(this.style))
    }
  }

  getChartyAxis(number: Number): EChartOption.YAxis[] {
    if (number < 2) {
      return [yAxis.getDefaultYaxisOfValue(this.style)]
    }
    let yAxisOption = [];
    for (let i = 0; i < number; i++) {
      yAxisOption.push(yAxis.getDefaultYaxisOfValue(this.style));
    }
    return yAxisOption;
  }

  //获取折线图默认series
  getDefaultLineSeries() {
    return series.getDefaultLineChartSeries();
  }

  getDefaultBarSeries() {
    return series.getDefaultBarChartSeries(this.style);
  }
  // 获取箱线图默认series
  getDefaultBoxPlotSeries() {
    return series.getDefaultBoxPlotSeries();
  }
  // 获取散点默认series
  getDefaultScatterSeries() {
    return series.getDefaultScatterSeries();
  }

  // 获取地图散点series
  getMapScatterSeries() {
    return series.getScatterOfMapSeries(this.style);
  }

  //获取默认tooltip 
  getDefaultTooltip() {
    return tooltip.getDefaultToolTipOfAxisChart();
  }
  // 获取盒须图tooltip
  getBoxPlotTooltip(unit: string = '') {
    return tooltip.getBoxPlotTooltipOfAxisChart(unit);
  }

  // 获取散点tooltip
  getScatterTooltip(unit?: string[]) {
    return tooltip.getTooltipOfScatter(unit);
  }
  // 获取散点折线tooltip
  getScatterLineTooltip(unit?: string[]) {
    return tooltip.getTooltipOfScatterLine(unit);
  }

  // 获取自定义比较图tooltip
  getCompareCustomTooltip(unit: string = '', years: string[] = ['', '']) {
    return tooltip.getCompareCustomTooltipOfAxisChart(unit, years);
  }

  // 获取多维度 轴tooltip
  getAxisChartWithMultiDimensionTooltip(unit: string[] = []) {
    return tooltip.getTooltipOfAxisChartWithMultiDimension(unit)
  }

  // 获取默认geo坐标系
  getDefaultGeo() {
    return geo.getCommonGeo(this.style, 'myMap')
  }

  // 获取分段visualMap 
  getPiecewiseVisualMap() {
    return visualMap.getVisualMapOfPiecewise(this.style);
  }

  // 获取连续visualMap
  getContinuousVisualMap() {
    return visualMap.getVisualMapOfContinuous(this.style);
  }

  // 获取比较图 自定义系列
  getCompareCustomSeries() {
    return series.getCompareCustomSeries();
  }

  // 获取仪表盘默认series
  getDefaultGaugeSeries() {
    return series.getIndexGaugeSeries(this.style)
  }

  // 获取指数仪表盘的tooltip
  getTooltipOfIndexGauge(detailText: { number: string, unit: string, itemText: string } = { number: '', unit: '', itemText: '' }) {
    return tooltip.getTooltipOfIndexGauge(detailText)
  }

  // 获取指数环形图的系列
  getIndexPieSeries() {
    return series.getIndexPieSeries(this.style);
  }

  // 获取进度环形图的系列
  getProgressPieSeries() {
    return series.getProgressPieSeries(this.style)
  }

  // 获取默认饼图系列
  getDefaultPieSeries() {
    return series.getDefaultPieChartSeries(this.style);
  }

  // 获取默认标题
  getDefaultChartTitle() {
    return title.getBottomTitle(this.style)
  }

  getInitOpts() {
    return initOpts.initOpts;
  }

  // 获取默认文字样式
  getTextStyle() {
    return textStyle.getTextStyle();
  }
}
